import React from "react";

const Shuttle = ({ ...props }) => {
  return (
    <svg
      width={321}
      height={426}
      viewBox="0 0 321 426"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={160.5} cy={75.5} r={75.5} fill="#fff" />
      <path
        d="M0 372.84L99.808 79 143 86.01l-25.098 286.83L56.616 426 0 372.84zM321 372.84L221.192 79 178 86.01l25.098 286.83L264.384 426 321 372.84z"
        fill="#fff"
      />
      <path
        d="M110 378.649L127.91 119h61.688L209 378.649 158.256 426 110 378.649z"
        fill="#fff"
      />
      <path
        d="M122 338.053L135.93 119h47.98L199 338.053 159.533 378 122 338.053z"
        fill="#FAFAFA"
      />
      <circle cx={149.5} cy={52.5} r={37.5} fill="#FAFAFA" />
      <circle cx={210.5} cy={75.5} r={12.5} fill="#FAFAFA" />
      <path fill="#1D3557" d="M85 76h151v43H85z" />
    </svg>
  );
};

export default Shuttle;
